import { render, staticRenderFns } from "./DealItemOptions.vue?vue&type=template&id=e0707b4c&scoped=true"
import script from "./DealItemOptions.vue?vue&type=script&lang=js"
export * from "./DealItemOptions.vue?vue&type=script&lang=js"
import style0 from "./DealItemOptions.vue?vue&type=style&index=0&id=e0707b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0707b4c",
  null
  
)

export default component.exports